import React, { Fragment, useRef, useState } from 'react';
import { TextField } from '@material-ui/core';
import { isNil } from 'lodash';
import ShippingData from "qs-data/shipping";
import DialogBox from "qs-common/DialogBox";
import CustomErrorComponent from 'qs-common/CustomErrorComponent';
import CustomCheckbox from 'qs-common/CustomCheckbox';
import Utility from 'qs-helpers/utility';
import { getI18N } from '../../../../i18N';
import "./style.scss";

export default function ({ selectedWeightProfile, showDialog, onClose, onSuccess, weightUnit, deleteMode }) {
    const minimumWeightRef = useRef();
    const maximumWeightRef = useRef();

    const [noMaxLimit, setNoMaxLimit] = useState(isNil(selectedWeightProfile) ? false : parseFloat(selectedWeightProfile.max) === -1);
    const [progressBar, setProgressBar] = useState(false);
    const [closeDialog, setCloseDialog] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);

    const { t } = getI18N();


    /* Add / Update Shipping mode api call */
    const addOrUpdateWeightProfile = async () => {
        setProgressBar(true);
        setErrorMessage(null);
        const newData = {
            "min": parseFloat(minimumWeightRef.current.value),
            "max": noMaxLimit ? -1 : parseFloat(maximumWeightRef.current.value)
        }
        if (isNil(selectedWeightProfile)) {
            ShippingData.addShippingWeightProfile(newData).then(() => {
                onApiSuccess();
            }).catch((err) => {
                onApiFailure(err)
            }).then(() => {
                setProgressBar(false)
            });
        } else {
            newData.id = selectedWeightProfile.id;
            ShippingData.updateShippingWeightProfile(newData).then(() => {
                onApiSuccess();
            }).catch((err) => {
                onApiFailure(err)
            }).then(() => {
                setProgressBar(false)
            });
        }
    }

    /* Delete Shipping mode api call */
    const deleteShippingWeight = async () => {
        setProgressBar(true);
        setErrorMessage(null);
        ShippingData.deleteShippingWeightProfile({ id: selectedWeightProfile.id }).then(() => {
            onApiSuccess();
        }).catch((err) => {
            onApiFailure(err)
        }).then(() => {
            setProgressBar(false)
        });
    }

    const onApiSuccess = () => {
        setCloseDialog(true);
        onSuccess();
    }

    const onApiFailure = (error) => {
        setErrorMessage(error);
    }

    const validateWeights = () => {
        if (Utility.isNumberInValid(minimumWeightRef)) {
            setErrorMessage(t('minimum_weight_should_not_be_less_than', { number : '0' }));
            return;
        }

        if (!noMaxLimit) {
            if (Utility.isNumberInValid(maximumWeightRef)) {
                setErrorMessage(t('maximum_weight_should_not_be_less_than', { number : '0' }));
                return;
            }
            if (parseFloat(maximumWeightRef.current.value) <= parseFloat(minimumWeightRef.current.value)) {
                setErrorMessage(t('maximum_weight_should_be_greater_than_minimum_weight'));
                return;
            }
        }

        setErrorMessage(null);
        addOrUpdateWeightProfile();
    }

    const onCheckedStatusChange = (e) => {
        setNoMaxLimit(e.target.checked);
        minimumWeightRef.current.focus();
    }

    return <DialogBox
        type={"simple"}
        dialogId={'#add-new-shipping-weight-profile'}
        show={showDialog}
        width={300}
        onClose={onClose}
        onSuccess={deleteMode ? deleteShippingWeight : validateWeights}
        primaryBtnText={deleteMode ? t('yes') : t('save')}
        showProgressBar={progressBar}
        closeDialog={closeDialog}
        showFooterDivider={!deleteMode}
        danger={deleteMode}
    >
        <Fragment>
            <div className='newWeightProfile'>
                <p className='dialogTitle'>
                    {deleteMode ? `${t('are_you_sure_you_want_to_delete_this_weight_profile')} : ${Utility.getWeightProfileName(selectedWeightProfile, weightUnit)}?`
                        : t('add_weight_profile')}
                </p>
                {!deleteMode && <div>
                    <div className='weightContainerWithUnit'>
                        <TextField
                            autoFocus
                            label={t('minimum_weight')}
                            disabled={progressBar}
                            defaultValue={!isNil(selectedWeightProfile) ? selectedWeightProfile.min : null}
                            inputRef={minimumWeightRef}
                            InputProps={{
                                inputProps: { min: 0 }
                            }}
                            fullWidth={true}
                            type='number' />
                        <span className='unit'>
                            {weightUnit}
                        </span>
                    </div>
                    {!noMaxLimit && <div className='weightContainerWithUnit'>
                        <TextField
                            label={t('maximum_weight')}
                            disabled={noMaxLimit || progressBar}
                            defaultValue={!isNil(selectedWeightProfile) ? (selectedWeightProfile.max === -1 ? null : selectedWeightProfile.max) : null}
                            inputRef={maximumWeightRef}
                            InputProps={{
                                inputProps: { min: 0 }
                            }}
                            fullWidth={true}
                            type='number' />
                        <span className='unit'>
                            {weightUnit}
                        </span>
                    </div>}
                    {noMaxLimit && <p className='noMaxLimitContent'>{t('unlimited_no_max_weight')}</p>}
                    <CustomCheckbox
                        checked={noMaxLimit}
                        label={t('no_upper_limit')}
                        handleChange={onCheckedStatusChange}
                    />
                    {errorMessage && <CustomErrorComponent errorMessage={errorMessage} />}
                </div>}
            </div>
        </Fragment>
    </DialogBox>
}
